import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SwPush } from '@angular/service-worker';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {
  
  private readonly VAPID_PUBLIC_KEY = 'BBpjuua6sqzltFZbNG1UwXvG_3-GIpbht5KqD2XbWjoGZSDCnGj2p99b00nRbJsTLS4l0ffpMfGCssGGdBzGJks';
  private apiUrl = 'https://tc2pnyfvif.execute-api.sa-east-1.amazonaws.com/notify/notificar';

  mensagem: string = '';
  senhaID: string = '';
  notificacaoPermitida!: string;
  idSenha = '0'; // <<== Usar sempre isso
  guiche = '0'; // <<== Usar sempre isso
  idLocal: string = '';

  constructor(    
    private swPush: SwPush,
    private http: HttpClient
  ) {}

//  async iniciarSolicitacao(): Promise<void> {
//     console.log('Verificando permissão...');
//     const jaRecarregou = localStorage.getItem('jaRecarregouNotificacao');
//     if (!jaRecarregou) {
//       await this.requestPermissionAndSubscribe(this.senhaID, this.idLocal);
//       // Marca que já recarregou
//       localStorage.setItem('jaRecarregouNotificacao', 'true');
//       // Recarrega uma única vez
//       window.location.reload();
//       return;
//     }
//     // Limpa o marcador para que em uma próxima tentativa (manual, por exemplo), o processo funcione novamente
//     localStorage.removeItem('jaRecarregouNotificacao');
//     console.log('Notification.permission => ', Notification.permission);
//   }

//   requestPermissionAndSubscribe(ID: string, local: string) {
//     Notification.requestPermission().then(async permission => {
//       if (permission === 'granted') {
//         await this.subscribeToPush(ID, local);
//       } else {
//         console.error('Permissão para notificações negada.');
//       }
//     });
//   }

//   private subscribeToPush(ID: string, local: string) {
//     this.swPush.requestSubscription({
//       serverPublicKey: this.VAPID_PUBLIC_KEY
//     })
//     .then(subscription => {
//       this.saveSubscription(ID, local, subscription)
//         .subscribe(() => console.log('Inscrição feita e enviada com sucesso!'));
//     })
//     .catch(err => console.error('Erro ao se inscrever no Push:', err));
//   }

//   private saveSubscription(ID: string, local: string, subscription: PushSubscription) {
//     const body = {
//       body: JSON.stringify({
//         ID,
//         local,
//         subscription
//       })
//     };  
//     return this.http.post('https://tc2pnyfvif.execute-api.sa-east-1.amazonaws.com/notify/salvar-subscription', body);
//   }
  
//     sendNotification(ID: string, guiche: string) {
//       const body = {
//         body: JSON.stringify({
//           ID,
//           guiche
//         })
//       };  
//       console.log(body)
//       return this.http.post(this.apiUrl, body); // Requisição POST com o corpo
//     }
    
}